import { useHiddenLimitOrderFeatureFlag } from '@paradigm/features/src/feature-flags/context';
import DrfqDetailsModal from './DrfqDetailsModal';
import DrfqHiddenLimitDetailsModal from './DrfqHiddenLimitDetailsModal';

export default function DrfqDetailsModalProvider() {
  const isHiddenLimitOrderEnabled = useHiddenLimitOrderFeatureFlag();

  if (isHiddenLimitOrderEnabled) {
    return <DrfqHiddenLimitDetailsModal />;
  }

  return <DrfqDetailsModal />;
}
